<template>
  <div>
  <swiper :options="swiperOption" :data="posts">
    <!-- v-for="(post, index) in posts" :key="index" -->
    <swiper-slide v-for="(post, index) in posts" :key="index" class="slide">
    <a v-bind:href="post['url']" target="_blank"><img class="img" v-bind:src="post['image']">
        <div class="bottom-right"><span class="blog-title">{{post['title']}}</span></div>
    </a>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "MultislideCarousel",
  props: {
    posts: {
      required: true
    }
  },
  data: () => ({
    title: "MultislideCarousel",
    swiperOption: {
      slidesPerView: 3.5,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    }
  }),
  components: {
    swiper,
    swiperSlide
  }
};
</script>
<style>
.container {
  position: relative;
  text-align: center;
  color: black;
}
.slide{
  width: 520px !important;
  text-align: center;
  margin: auto;
  padding: 1%;
}
.bottom-right {
  position: absolute;
  bottom: 20px;
  font-size: 17px;
  opacity: 0.7;
  background-color: aliceblue;
  padding: 2%;
  width: 100%;
}
.blog-title{
  color:black;
  font-weight: 800;
}
.dark-theme .swiper-container{
  background-color: #252c3e;
}

.dark-theme .swiper-pagination-bullet {
  background: #fff;
  opacity: 0.5;
}

.dark-theme .swiper-pagination-bullet-active {
  opacity: 1;
  background: #007aff;
}

.dark-theme .blog-title {
  color: white;
}

.dark-theme .bottom-right {
  background-color: rgba(57, 65, 86, .5);
  opacity: 1;
}

</style>